import { BiddingTaskTypes } from 'store/modules/bidding_store/types';

export enum AiManagementTypes {
  GET_COLUMNS_REQUEST = '@ai_management/GET_COLUMNS_REQUEST',
  GET_COLUMNS_SUCCESS = '@ai_management/GET_COLUMNS_SUCCESS',
  GET_COLUMNS_FAILURE = '@ai_management/GET_COLUMNS_FAILURE',
  REORDER_COLUMNS = '@ai_management/REORDER_COLUMNS',
  RENAME_COLUMN = '@ai_management/RENAME_COLUMN',
  RECOLOR_COLUMN = '@ai_management/RECOLOR_COLUMN',
  REMOVE_COLUMN = '@ai_management/REMOVE_COLUMN',
  GET_CARDS_REQUEST = '@ai_management/GET_CARDS_REQUEST',
  GET_CARDS_SUCCESS = '@ai_management/GET_CARDS_SUCCESS',
  GET_CARDS_FAILURE = '@ai_management/GET_CARDS_FAILURE',
  MOVE_CARD = '@ai_management/MOVE_CARD',
  REMOVE_CARD = '@ai_management/REMOVE_CARD',
  UPSERT_CARD = '@ai_management/UPSERT_CARD',
  MOVE_TASK = '@ai_management/MOVE_TASK',
  GET_TASKS_REQUEST = '@ai_management/GET_TASKS_REQUEST',
  GET_TASKS_SUCCESS = '@ai_management/GET_TASKS_SUCCESS',
  GET_TASKS_FAILURE = '@ai_management/GET_TASKS_FAILURE',
  GET_TEAM_REQUEST = '@ai_management/GET_TEAM_REQUEST',
  GET_TEAM_SUCCESS = '@ai_management/GET_TEAM_SUCCESS',
  GET_TEAM_FAILURE = '@ai_management/GET_TEAM_FAILURE',
  SET_FILTERS = '@ai_management/SET_FILTERS',
}

export type AiManagementSystemKey = 'analyze' | 'participate' | 'finished';

export interface AiManagementColumnPermissions {
  renameable: boolean;
  deletable: boolean;
  reorderable: boolean;
  accepts_cards: boolean;
}

export interface AiManagementColumn {
  id: number;
  name: string;
  system_key: AiManagementSystemKey | null;
  template_key: string | null;
  sort_group: number;
  position: number;
  color: string;
  wip_limit: number | null;
  cards_count: number;
  total_cards_count: number;
  permissions: AiManagementColumnPermissions;
}

export interface AiManagementBoard {
  id: number;
  name: string;
  client_id: number;
}

export interface AiManagementCardMember {
  id: number;
  name: string;
  initials: string;
}

export interface AiManagementCardCounts {
  tasks: number;
  comments: number;
  attachments: number;
  updates?: number;
}

export interface AiManagementCardBidding {
  notice_number: string;
  public_body: string;
  city: string;
  state: string;
  object: string;
  deadline_at: string | null;
  opening_at: string | null;
  document_at: string | null;
}

export interface AiManagementCard {
  id: number;
  bidding_id: number;
  column_id: number;
  position: number;
  entered_column_at: string;
  members: AiManagementCardMember[];
  counts: AiManagementCardCounts;
  bidding: AiManagementCardBidding;
  archived_by?: { id: number; name: string } | null;
  archived_at?: string | null;
}

export type AiManagementCardsByColumn = Record<number, AiManagementCard[]>;

export interface AiManagementTeamMember {
  id: number;
  name: string;
  initials: string;
}

export interface AiManagementFilters {
  memberIds: number[];
  scope: 'mine' | null;
  q: string;
  deadlineFrom: string | null;
  deadlineTo: string | null;
}

export interface RequestFlags {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface AiManagementTaskColumnPermissions {
  renameable: boolean;
  deletable: boolean;
  reorderable: boolean;
}

export interface AiManagementTaskColumn {
  id: number;
  name: string;
  system_key: string | null;
  sort_group: number;
  position: number;
  color: string;
  tasks_count: number;
  permissions: AiManagementTaskColumnPermissions;
}

export interface AiManagementTaskBidding {
  id: number;
  notice_number: string;
  public_body: string;
  city: string;
  state: string;
}

export interface AiManagementBoardTask extends BiddingTaskTypes {
  bidding: AiManagementTaskBidding;
}

export interface AiManagementTasksByColumn {
  [columnId: number]: AiManagementBoardTask[];
}

export interface AiManagementState {
  board: AiManagementBoard | null;
  columns: AiManagementColumn[];
  cards: AiManagementCardsByColumn;
  taskColumns: AiManagementTaskColumn[];
  tasks: AiManagementTasksByColumn;
  team: AiManagementTeamMember[];
  filters: AiManagementFilters;
  request: {
    columns: RequestFlags;
    cards: RequestFlags;
    tasks: RequestFlags;
    team: RequestFlags;
  };
}

export interface SidebarItem {
  key: string;
  label: string;
  icon: string;
}

export interface SidebarGroup {
  key: string;
  label: string;
  items: SidebarItem[];
}

export interface PanelStat {
  key: 'anotacoes' | 'tarefas' | 'atualizacoes' | 'chat';
  icon: string;
  label: string;
}

export interface PanelShortcut {
  icon: string;
  label: string;
  target: string;
  linkLabel: string;
  badge?: string;
}

export interface PanelSection {
  key: string;
  icon: string;
  title: string;
  target: string | null;
  empty: string;
}
